import { Note } from "../shared/models/note.model"
import { proxy } from "valtio"
import { Notebook } from "../shared/models/notebook.model"

export interface INotebookState {
	notes: Note[]
	noteSelected: Note
}

export const notebookStore = proxy({
	notes:[] as Note[],
	notebook: new Notebook(),
	noteSelected: new Note(),
	setNotebooksAction: (value: Notebook) => {
		notebookStore.notebook = value;
	},
	setPagesAction: (value: Note[]) => {
		notebookStore.notebook.pages = value;
	},
	selectNoteAction: (value: Note) => {
		notebookStore.noteSelected = value;
	}
})
